<template>
<div class="textcontainer">
<tech></tech>
</div>
</template>

<script>
import tech from '../assets/md/tech.md';
// this is just a shell component for the markdown now, in case I want to directly mess with non-markdown parts later.

export default {
     components: {tech}
}

</script>



// WEBPACK FOOTER //
// tech.vue?2a0c3dd6